import { render, staticRenderFns } from "./RulesByApprovalWorkflow.vue?vue&type=template&id=c3495224"
import script from "./RulesByApprovalWorkflow.vue?vue&type=script&lang=js"
export * from "./RulesByApprovalWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports